module.exports = __webpack_public_path__ + "static/img/icon_sort_descend.8acc37b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_sort_descend.png
// module id = rUa3
// module chunks = 31